import React from 'react';
import {Input} from './Input';

export class Textarea extends React.Component {
  render() {
    return (
      <Input
        {...{
          ...this.props,
          multiline: true,
          rows: 6,
          rowsMax: 6,
          variant: 'outlined',
        }}
      />
    );
  }
}
